import { render } from "./login_vue.vue?vue&type=template&id=fa84ee8a&scoped=true"
import script from "./login_vue.vue?vue&type=script&lang=js"
export * from "./login_vue.vue?vue&type=script&lang=js"

import "./login_vue.vue?vue&type=style&index=0&id=fa84ee8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa84ee8a"]])

export default __exports__